import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { ICON } from 'resources/constants';

import {
  Container,
  Wrapper,
  TopWrapper,
  BottomWrapper,
  Title,
  Text,
  ImageWrapper,
  Image,
  CarouselDots,
  Button,
  BottomBar,
  NavigationButton,
  ButtonSpace,
} from './elements';

type ScreenProps = {
  readonly title: string;
  readonly text: string;
  readonly imageUrl: string;
  readonly buttonText?: string;
  readonly buttonAction?: () => void;
  readonly theme: string;
  readonly totalSlides: number;
};

const deps = {
  currentOnboardingIndex: state.account.currentOnboardingIndex,
  changeOnboardingIndex: sequences`account.changeOnboardingIndex`,
};

function Screen({
  title,
  text,
  imageUrl,
  buttonText,
  buttonAction,
  theme,
  totalSlides,
  currentOnboardingIndex,
  changeOnboardingIndex,
}: typeof deps & ConnectedProps & ScreenProps): React.ReactElement {
  const first = currentOnboardingIndex === 0;
  const last = currentOnboardingIndex === totalSlides - 1;

  return (
    <Container theme={theme}>
      <Wrapper>
        <TopWrapper>
          <Title theme={theme}>{title}</Title>
          <Text theme={theme}>{text}</Text>
        </TopWrapper>
        <BottomWrapper>
          <ImageWrapper>
            <Image src={imageUrl} />
          </ImageWrapper>
          <CarouselDots
            currentSlideIndex={currentOnboardingIndex + 1}
            slideCount={totalSlides}
            color={theme === 'light' ? '#35b8c4' : '#fff'}
            theme={theme}
            changeDot={index => {
              changeOnboardingIndex({ newIndex: index });
            }}
          />
          {buttonText ? (
            <Button
              onClick={() => {
                buttonAction();
              }}
            >
              {buttonText}
            </Button>
          ) : (
            <ButtonSpace />
          )}
        </BottomWrapper>
      </Wrapper>

      <BottomBar>
        <NavigationButton
          theme={theme}
          icon={ICON.keyboardArrowLeft}
          hidden={first}
          onClick={() => {
            if (!first) {
              return changeOnboardingIndex({
                newIndex: currentOnboardingIndex - 1,
              });
            }

            return null;
          }}
        />
        <NavigationButton
          theme={theme}
          icon={ICON.keyboardArrowRight}
          hidden={last}
          onClick={() => {
            if (!last) {
              return changeOnboardingIndex({
                newIndex: currentOnboardingIndex + 1,
              });
            }

            return null;
          }}
        />
      </BottomBar>
    </Container>
  );
}

export default connect<ScreenProps, typeof deps>(deps, Screen);
